import _ from 'lodash';
import moment from 'moment';
import React, { Component } from 'react';
import { connect } from 'react-redux';

import { Link } from 'react-router-dom';

import ReactTooltip from 'react-tooltip';

import {
  getIcon,
  getLetterScoreForSprintActivityItems,
  getLetterScoreForSprintDevelopmentItems,
} from '../../util';

import {
  fetchUserDataForEveryone
} from '../../actions';

import {
  fetchSprintHistoryForEveryone
} from '../../actions/sprint';

class SprintHistoryItem extends Component {

  state = {

  }

  generateRandomSprintScore(){

    const randRating1 = Math.min(Math.floor((Math.random()*10 + 2) /2), 5);
    const randRating2 = Math.min(Math.floor((Math.random()*10 + 2) /2), 5);
    const randCompletionPercent1 = Math.min(Math.ceil(Math.pow(Math.random(), .75)*120), 100);
    const randCompletionPercent2 = Math.min(Math.ceil(Math.pow(Math.random(), .75)*120), 100);
    const randCompletionPercent3 = Math.min(Math.ceil(Math.pow(Math.random(), 1)*120), 100);

    const randTotalCompletionPercent = Math.min(Math.ceil(Math.pow(Math.random(), .65)*120), 100);

    return {
      ratingUser: randRating1,
      ratingManager: randRating2,
      activityCompletion: randCompletionPercent1,
      behaviorCompletion: randCompletionPercent2,
      skillCompletion: randCompletionPercent3,
      ratingAverage: randRating1 + randRating2,
      completionAverage: randTotalCompletionPercent /*Math.ceil((randCompletionPercent1 + randCompletionPercent2 + randCompletionPercent3) / 3)*/
    }
  }

  getSprintHistoryTooltip(startDate, endDate, developmentScore, activityScore, managerRating, userRating){
    const dateRangeText = moment(startDate, 'YYYYMMDD').format('MMM D') + ' - ' + moment(endDate, 'YYYYMMDD').format('MMM D');
    const activityPerentComplete = activityScore.letterGrade !== "I" ? activityScore.adjustedPercentComplete : 'N/A';
    const developmentPerentComplete = developmentScore.letterGrade !== "I" ? developmentScore.adjustedPercentComplete : 'N/A';
    const activityLetter = activityScore.letterGrade !== "I" ? ` (${activityScore.letterGrade})` : '';
    const developmentLetter = developmentScore.letterGrade !== "I" ? ` (${developmentScore.letterGrade})` : '';
    return `${dateRangeText}<br/><br/>Adjusted Activity Score: <b>${activityPerentComplete}</b>${activityLetter}<br/>Adjusted Development Score: <b>${developmentPerentComplete}</b>${developmentLetter}<br/><br/>Manager Rating: ${managerRating}/5<br/>User Rating: ${userRating}/5`;
  }

  renderLetterGrade(letter){
    if(letter === 'I'){
      //incomplete
      return getIcon('times');
    }
    else{
      return letter;
    }
  }

  render(){

    // console.log('rendering sprint history item with sprintHistory prop: ', this.props.sprintHistory);

    const {
      startDate,
      endDate,
      _id,
      goals,
      userId,
      managerRating,
      userRating,
    } = this.props.sprintHistory;

    let developmentItems = [];
    let activityItems = [];

    _.each(goals, ({ goalType, goalValue, category, goalTarget }) => {
      if(goalType === 'do'){
        developmentItems.push(((goalValue || {}).applied ? 1 : 0) + ((goalValue || {}).practiced ? 1 : 0) + ((goalValue || {}).improved ? 1 : 0));
      }
      else if(category === 'activity' && goalTarget){
        // console.log('pushing activity score of: ', (goalValue || 0) * 100 / goalTarget);
        activityItems.push(Math.ceil((goalValue || 0) * 100 / goalTarget));
      }
      else{
        //nothing
      }
    });

    // console.log('developmentItems: ', developmentItems);

    const developmentScore = getLetterScoreForSprintDevelopmentItems(developmentItems);
    const activityScore = getLetterScoreForSprintActivityItems(activityItems);

    // console.log('developmentScore: ', developmentScore);
    // console.log('activityScore: ', activityScore);

    const fakeScores = this.generateRandomSprintScore();

    return (
      <Link to={`/people/${userId}/sprint`} target="_blank">
        <div key={_id} className="history-item" data-for={`sprint-history-item-${_id}`} data-tip={this.getSprintHistoryTooltip(startDate, endDate, developmentScore, activityScore, managerRating, userRating)} data-html={true}>
          <div className={`activity letter-${activityScore.letterGrade}`}>{this.renderLetterGrade(activityScore.letterGrade)}</div>
          <div className={`development letter-${developmentScore.letterGrade}`}>{this.renderLetterGrade(developmentScore.letterGrade)}</div>
        </div>
        <ReactTooltip id={`sprint-history-item-${_id}`} effect="solid" place="top" />
      </Link>
    )
  }
}

export default SprintHistoryItem;



// WEBPACK FOOTER //
// ./src/components/reports/sprintHistoryItem.js